import React from 'react';
import { usePaperTrading } from '../../contexts/PaperTradingContext';
import { Clock, ArrowUpRight, ArrowDownRight } from 'lucide-react';

export const TradeHistory = () => {
    const { tradeHistory } = usePaperTrading();

    if (!tradeHistory || tradeHistory.length === 0) {
        return (
            <div className="bg-white/[0.02] border border-white/5 rounded-2xl p-6 lg:p-8 relative overflow-hidden h-full flex items-center justify-center">
                <div className="text-center">
                    <Clock className="w-12 h-12 text-muted-foreground/30 mx-auto mb-4" />
                    <h3 className="text-xl font-bold mb-2">No Trading History</h3>
                    <p className="text-muted-foreground text-sm">
                        Your recent transactions will appear here safely.
                    </p>
                </div>
            </div>
        );
    }

    const formatDate = (dateValue) => {
        if (!dateValue) return 'Unknown Date';
        // Handle Firestore Timestamp object
        if (dateValue.seconds) {
            return new Date(dateValue.seconds * 1000).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
        }
        // Handle JS Date object or valid date string/number
        const date = new Date(dateValue);
        if (!isNaN(date.getTime())) {
            return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
        }
        return 'Invalid Date';
    };

    return (
        <div className="bg-white/[0.02] border border-white/5 rounded-2xl p-6 lg:p-8 relative overflow-hidden h-full">
            <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
                <Clock className="w-5 h-5 text-primary" />
                Recent Transactions
            </h2>

            <div className="space-y-4">
                {tradeHistory.slice(0, 5).map((trade, idx) => (
                    <div key={trade.id || idx} className="bg-black/40 border border-white/5 rounded-xl p-4 flex items-center justify-between hover:bg-white/[0.02] transition-colors">
                        <div className="flex items-center gap-4">
                            <div className={`p-2 rounded-lg ${trade.side === 'YES' ? 'bg-emerald-500/10 text-emerald-400' : 'bg-red-500/10 text-red-400'}`}>
                                {trade.side === 'YES' ? <ArrowUpRight className="w-4 h-4" /> : <ArrowDownRight className="w-4 h-4" />}
                            </div>
                            <div>
                                <div className="font-semibold">{trade.marketTitle}</div>
                                <div className="text-xs text-muted-foreground flex gap-2">
                                    <span>{formatDate(trade.timestamp)}</span>
                                    <span>•</span>
                                    <span>Bought {trade.side} @ ${Number(trade.price).toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                        <div className="text-right">
                            <div className="font-bold font-mono">${Number(trade.amount).toFixed(2)}</div>
                            <div className="text-xs text-muted-foreground">Amount</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
